import { useLanguage } from '../../context/LanguageContext';

export default function LanguageSwitcher({ className = '' }) {
  const { language, changeLanguage, supportedLanguages } = useLanguage();

  return (
    <div className={`flex items-center gap-1 ${className}`}>
      {supportedLanguages.map((lang) => (
        <button
          key={lang}
          onClick={() => changeLanguage(lang)}
          className={`
            px-3 py-2 min-h-[44px]
            text-sm font-medium uppercase
            rounded-lg
            transition-colors
            ${language === lang
              ? 'bg-primary-100 dark:bg-primary-900/30 text-primary-700 dark:text-primary-400'
              : 'text-gray-600 dark:text-gray-400 hover:bg-gray-100 dark:hover:bg-gray-800'
            }
          `}
          aria-label={`Switch to ${lang === 'de' ? 'German' : 'English'}`}
          aria-pressed={language === lang}
        >
          {lang}
        </button>
      ))}
    </div>
  );
}
